const d3 = require('d3');

export default () => {
  const { svg, zoom } = window;
  const isMobile = window.innerWidth < 769;
  if (!svg || !zoom) return false;
  // debugger;
  // const svgNode = svg._groups[0][0];
  // const width = Number(svgNode.getAttribute('width'));
  // const height = Number(svgNode.getAttribute('height'));

  svg.transition()
    .duration(750)
    .call(zoom.transform, d3.zoomIdentity)
    .call(zoom.transform, d3.zoomIdentity.translate(isMobile ? -1498 : -1400, -1070).scale(2));
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/map/utlis/resetZoom.js